export const DPR_DAILY_PROJECT_STATUS = {
  PRODUCTION: 'Production',
  INSTALLATION_PRODUCTION_TEST: 'Installation & Production Test',
};

export const DPR_DAILY_PROJECT_STATUS_OPTIONS = [
  { value: '', label: 'Select status' },
  { value: DPR_DAILY_PROJECT_STATUS.PRODUCTION, label: 'Production' },
  {
    value: DPR_DAILY_PROJECT_STATUS.INSTALLATION_PRODUCTION_TEST,
    label: 'Installation & Production Test',
  },
];

const REPORT_PIPELINE_STATUSES = new Set([
  DPR_DAILY_PROJECT_STATUS.PRODUCTION,
  DPR_DAILY_PROJECT_STATUS.INSTALLATION_PRODUCTION_TEST,
]);

/** Ongoing pipeline dropdown is shown only when status is Production. */
export const showOngoingPipelineSelectForStatus = (status) =>
  String(status || '').trim() === DPR_DAILY_PROJECT_STATUS.PRODUCTION;

/** Save, submit, and report generation require an ongoing pipeline for these statuses. */
export const statusRequiresOngoingPipelineForReport = (status) =>
  REPORT_PIPELINE_STATUSES.has(String(status || '').trim());

export const buildDprReportContextParams = ({
  ongoingPipelineId,
  dprProjectStatus,
  requireOngoingPipeline = false,
} = {}) => {
  const params = {};
  if (dprProjectStatus) {
    params.dprProjectStatus = dprProjectStatus;
  }
  if (ongoingPipelineId != null && ongoingPipelineId !== '') {
    params.ongoingPipelineId = Number(ongoingPipelineId);
  } else if (requireOngoingPipeline) {
    return null;
  }
  return params;
};

export const ONGOING_PIPELINE_REQUIRED_MESSAGE =
  'Select an ongoing pipeline before generating a report. Set status to Production in the DPR header to choose a pipeline, then save the DPR.';
